import 'babel-polyfill';
import 'url-search-params-polyfill';
import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import Vuetify from 'vuetify/lib';
import store from './plugins/vuex';
import i18n from './i18n';
import Hotjar from 'vue-hotjar';
import * as Sentry from '@sentry/vue';
import { version } from '../package.json';

// eslint-disable-next-line
console.info(`SalesCloud eTags v${version}`);

if (process && process.env) {
  if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
      Vue,
      dsn: process.env.VUE_APP_SENTRY_DSN,
      version,
      release: version,
      environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
      tracesSampleRate: 0,
    });
  }

  if (process.env.VUE_APP_HOTJAR_ID) {
    Vue.use(Hotjar, {
      id: process.env.VUE_APP_HOTJAR_ID, // Hotjar Site ID
    });
  }
}

const vuetifyOptions = {
  icons: {
    iconfont: 'mdi',
  },
};

Vue.use(Vuetify);
Vue.config.productionTip = false;

new Vue({
  store,
  vuetify: new Vuetify(vuetifyOptions),
  i18n,
  render: (h) => h(App),
}).$mount('#app');
